import { render, staticRenderFns } from "./modal-batch-approval-list.vue?vue&type=template&id=0d0eecc8&scoped=true"
import script from "./modal-batch-approval-list.vue?vue&type=script&lang=js"
export * from "./modal-batch-approval-list.vue?vue&type=script&lang=js"
import style0 from "./modal-batch-approval-list.vue?vue&type=style&index=0&id=0d0eecc8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d0eecc8",
  null
  
)

export default component.exports